import { useRef } from 'react'

export interface PublisherAdContainerProps {
  className?: string
  idPrefix?: string
}

export function PublisherAdContainer({ className = '', idPrefix = 'kwry-ad' }: PublisherAdContainerProps) {
  // Generate ID internally
  const adId = useRef(idPrefix)
  
  return (
    <div 
      id={adId.current}
      className={`publisher-ad-container ${className}`}
      style={{
        width: '100%',
        maxWidth: '728px',
        height: '90px',
        backgroundColor: '#f0f0f0',
        border: '2px dashed #ccc',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '8px',
        margin: '16px auto'
      }}
    >
      <div style={{ color: '#666', fontSize: '14px', textAlign: 'center' }}>
        📢 Ad Placeholder<br />
        <small>ID: {adId.current}</small>
      </div>
    </div>
  )
}
